module.exports = __webpack_public_path__ + "media/bootstrap-icons/mailbox2-01cc75d9.svg";